// Get Inventory Items Use Case

import {InventoryRepository} from '../repository/InventoryRepository';
import {InventoryItem, InventoryFilters} from '../models/inventory.model';

export class GetInventoryItemsUseCase {
  constructor (private inventoryRepository: InventoryRepository) {}

  async execute (filters?: InventoryFilters, page = 1, limit = 20): Promise<InventoryItem[]> {
    try {
      const items = await this.inventoryRepository.getAllInventoryItems(filters, page, limit);
      return items;
    } catch (error) {
      throw error;
    }
  }
}
